/** @jsx jsx */

import { jsx, render, SelectionSet, Field, Variable, Mutation } from "graphql-jsx";
import { clients } from "utils/clients";
import { UuidScalar } from "GraphQL/Scalars";

type Option = Readonly<{
  uuid?: string;
}>;

export const DeleteMetadataElementRelation = async (option: Option) => {
  const $uuid = <Variable name="uuid" scalar={<UuidScalar isNullable={true} />} value={option.uuid} />;
  const { query, variables } = render(
    <Mutation operationName="DELETE_METADATA_ELEMENT_RELATION">
      <SelectionSet
        name="deleteMetadata_self_relations_element_metadata"
        alias="deleteMetadataSelfRelationsElementMetadata"
        argument={{
          where: {
            id: $uuid
          }
        }}
      >
        <Field name="id" />
      </SelectionSet>
    </Mutation>
  );
  type Data = Readonly<{
    deleteMetadataSelfRelationsElementMetadata: Readonly<{
      id: string;
    }>[];
  }>;
  return await clients.metadata.request<Data>(query, variables);
};
